/**
 * DS-internal hook : un lecteur d'écran est-il actif (VoiceOver, TalkBack) ?
 *
 * Comme `useReduceMotion` : `AccessibilityInfo` répond, puis suit les changements. Un composant qui se
 * retire seul le lit pour laisser le temps d'atteindre son geste.
 */
import { useEffect, useState } from "react"
import { AccessibilityInfo } from "react-native"

export function useScreenReader(): boolean {
    const [enabled, setEnabled] = useState(false)

    useEffect(() => {
        let alive = true
        AccessibilityInfo.isScreenReaderEnabled().then((on) => {
            if (alive) setEnabled(on)
        })
        const sub = AccessibilityInfo.addEventListener("screenReaderChanged", setEnabled)
        return () => {
            alive = false
            sub.remove()
        }
    }, [])

    return enabled
}
